export const APPROVED_SOFTWARE = {
  TITLE: 'Approved Software',
  SEARCH_PLACEHOLDER: 'Search software...',
  TABLE: {
    SOFTWARE_NAME: 'Software Name',
    VENDOR: 'Vendor',
    VERSION: 'Version',
    PLATFORMS: 'Platforms',
    ADDED_BY: 'Added By',
  },
  DRAWER: {
    ADD_TITLE: 'Add Software',
    EDIT_TITLE: 'Edit Software',
    FIELDS: {
      SOFTWARE_NAME: 'Software Name',
      VENDOR: 'Vendor',
      VERSION: 'Version',
      PLATFORMS: 'Platforms',
      ADDED_BY: 'Added By',
    },
    ALL_VERSIONS: 'All versions',
    ALL: 'All',
    SELECT_GROUP: 'Select a group',
    SEARCH_VENDOR: 'Search vendors...',
    LOADING: 'Loading...',
    NO_VENDOR_FOUND: 'No vendor found',
  },
  HIDE_UTILITIES: 'Hide utilities',
  UTILITY: 'Utility',
  NO_SOFTWARE: 'No approved software yet.',
  NO_RESULTS: 'No software matches your filters.',
  EXPORT_EMPTY: 'There is no software to export with the current filters.',
  ACTIONS: {
    ADD_SOFTWARE: 'Add Software',
    EXPORT: 'Export CSV',
    SAVE_CHANGES: 'Save Changes',
    CANCEL: 'Cancel',
  },
  DELETE_DIALOG: {
    TITLE: 'Delete Software',
    DESCRIPTION_PREFIX: 'Are you sure you want to delete',
    DESCRIPTION_SUFFIX: '? This action cannot be undone.',
    CONFIRM: 'Delete',
    CANCEL: 'Cancel',
  },
  MESSAGES: {
    CREATE_SUCCESS: 'Software created successfully',
    UPDATE_SUCCESS: 'Software updated successfully',
    DELETE_SUCCESS: 'Software deleted successfully',
  },
} as const
